import { Button, Modal } from "antd";
import React, { useState } from "react";

export default function EducationDetail({ value }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button onClick={showModal}>Know More</Button>
      <Modal
        title=""
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        footer={[
          <Button onClick={handleCancel} className="bg-dark text-white">
            Close
          </Button>,
        ]}
        closeIcon={false}
        width={900}
      >
        <div className="questionDetail">
          <div className="row">
            {value.img && (
              <div className="col-md-4 d-flex justify-content-center">
                <img style={{ maxWidth: "100%", maxHeight:"400px" }} src={value.img} />
              </div>
            )}
            <div className={`${value.img ? "col-md-8" : "col-12"}`}>
              <h3>{value.question}</h3>
              {value.desc.map((val) => (
                <p>{val}</p>
              ))}
              {value.list.length > 0 &&
                value.list.map((val, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: val }}></p>
                ))}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
